import { Button, Checkbox, FormScroll, Icon, Pill, PillCluster, Tabs, TopBar } from 'admination-react'
import { useState } from 'react'
import type { Variant } from '@/core/api/auth'
import type { Organisation } from '@/core/data/organisation'
import { TextField } from '@/core/components/form/TextField'
import { toastBlocked } from '@/core/lib/toast'

const FIELDS = [
  ['name', 'Name der Organisation'], ['telefonnummer', 'Telefonnummer'], ['kontakt_email', 'Kontakt-E-Mail'],
  ['strasse', 'Straße'], ['hausnummer', 'Hausnummer'], ['plz', 'PLZ'], ['ort', 'Ort'],
  ['durchf_strasse', 'Straße des Durchführungsorts'], ['durchf_hausnummer', 'Hausnummer des Durchführungsorts'],
  ['durchf_plz', 'PLZ des Durchführungsorts'], ['durchf_ort', 'Ort der Durchführung'],
] as const satisfies ReadonlyArray<readonly [keyof Organisation, string]>
const GROUPS = [
  { label: 'Kontakt', fields: FIELDS.slice(0, 3) },
  { label: 'Anschrift', fields: FIELDS.slice(3, 7) },
  { label: 'Durchführungsort', fields: FIELDS.slice(7) },
]
export type OrganisationDraft = { data: { [Key in keyof Organisation]: string }; variants: string[] }
export function emptyOrganisationDraft(): OrganisationDraft {
  return { data: { name: '', telefonnummer: '', kontakt_email: '', strasse: '', hausnummer: '', plz: '', ort: '', durchf_strasse: '', durchf_hausnummer: '', durchf_plz: '', durchf_ort: '' }, variants: [] }
}

export function CreateOrganisation({ value, onChange, variants, onBack, onSubmit, busy, requiresAzav, variantsLocked = false }: {
  value: OrganisationDraft
  onChange: (draft: OrganisationDraft) => void
  variants: readonly Variant[]
  onBack: () => void
  onSubmit: () => void
  busy: boolean
  requiresAzav: boolean
  variantsLocked?: boolean
}) {
  const [attempted, setAttempted] = useState(false)
  function submit() {
    if (busy) return
    setAttempted(true)
    if (!FIELDS.every(([key]) => value.data[key]?.trim())) { toastBlocked('Bitte ergänzen Sie die Organisationsdaten.'); return }
    if (!value.variants.length) { toastBlocked('Bitte wählen Sie mindestens eine Maßnahmen-Art aus.'); return }
    if (requiresAzav && !value.variants.includes('azav')) { toastBlocked('Bitte wählen Sie AVGS aus, um das Erstgespräch fortzusetzen.'); return }
    onSubmit()
  }
  return <>
    <TopBar className="bar--responsive" back={{ label: 'Zurück', onClick: onBack, disabled: busy }}
      left={{ type: 'title', label: 'Organisation erstellen', icon: 'i-building', active: false }}
      center={<Tabs items={[{ name: 'organisation', label: 'Organisationsdaten', icon: 'i-building' }]} activeName="organisation" onChange={() => {}} />}
      right={<PillCluster><Pill><Button primaryAction loading={busy} onClick={submit}><Icon name="i-arrow-right" />Weiter</Button></Pill></PillCluster>}
    />
    <FormScroll aria-label="Organisation erstellen"><div className="form-column">
      {GROUPS.map((group) => <section className="section" key={group.label}><h3 className="section-header">{group.label}</h3><div className="section-body">
        {group.fields.map(([key, label]) => <TextField key={key} label={label} value={value.data[key] ?? ''} required readOnly={busy}
          invalid={attempted && !value.data[key]?.trim()} onChange={(next) => onChange({ ...value, data: { ...value.data, [key]: next } })} />)}
      </div></section>)}
      <section className="section"><h3 className="section-header">Maßnahmen-Arten</h3><div className="section-body">
        {variants.map((variant) => <Checkbox key={variant.key} disabled={busy || variantsLocked} checked={value.variants.includes(variant.key)} onChange={() => onChange({
          ...value, variants: value.variants.includes(variant.key) ? value.variants.filter((key) => key !== variant.key) : [...value.variants, variant.key],
        })}>{variant.key === 'azav' ? 'AVGS' : variant.name}</Checkbox>)}
      </div></section>
    </div></FormScroll>
  </>
}
